import React, { lazy, Suspense } from 'react';
import Loader from '../../components/Loader/Loader.lazy';

const LazyLogin = lazy(() => import('./Login'));

const Login = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyLogin {...props} />
  </Suspense>
);

export default Login;
